import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  useMediaQuery,
  useTheme,
  Grid,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const SizeChartPopUp = ({ open, setOpen,sizeData }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // const sizeData = {
  //   "Width, in": {
  //     "XS": 19.62,
  //     "S": 20.87,
  //     "M": 22.5,
  //     "L": 24.0,
  //     "XL": 26.0,
  //     "2XL": 28.37
  //   },
  //   "Length, in": {
  //     "XS": 27.5,
  //     "S": 28.25,
  //     "M": 29.25,
  //     "L": 30.0,
  //     "XL": 30.75,
  //     "2XL": 31.75
  //   },
  //   "Sleeve length, in": {
  //     "XS": 26.0,
  //     "S": 26.25,
  //     "M": 26.5,
  //     "L": 27.0,
  //     "XL": 27.25,
  //     "2XL": 27.5
  //   }
  // };

  const sizes = ["XS", "S", "M", "L", "XL", "2XL"];
  const measurements = Object.keys(sizeData);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: isMobile ? { maxHeight: "70vh" } : { maxHeight: "80vh" },
      }}
    >
      {/* Title with Close Button */}
      <DialogTitle>
        Size Chart
        <IconButton
          style={{ position: "absolute", right: 10, top: 10 }}
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Size Chart Table */}
      <DialogContent dividers>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={headerStyle}>Size</th>
                {measurements.map((measurement) => (
                  <th key={measurement} style={headerStyle}>
                    {measurement}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sizes.map((size) => (
                <tr key={size}>
                  <td style={cellStyle}>{size}</td>
                  {measurements.map((measurement) => (
                    <td key={measurement} style={cellStyle}>
                      {sizeData[measurement][size]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </DialogContent>

      {/* Bottom Button */}
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          style={{
            fontSize: "12px",
            backgroundColor: "#232F3E",
            width: "150px",
            fontWeight: "bold",
          }}
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const headerStyle = {
  border: "1px solid #ddd",
  padding: "12px",
  backgroundColor: "#f2f2f2",
  textAlign: "center",
  fontWeight: "bold"
};

const cellStyle = {
  border: "1px solid #ddd",
  padding: "12px",
  textAlign: "center"
};

export default React.memo(SizeChartPopUp);
